// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3fRhx","title":"Header_title__3trTM","left":"Header_left__2RMFg","clinicName":"Header_clinicName__1wA9d"};